import { Button } from "react-bootstrap";

interface SecondarySmallButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

const SecondarySmallButton = ({ 
  onClick, 
  disabled = false, 
  children,
  icon
}: SecondarySmallButtonProps) => {
  return (
    <Button
      onClick={onClick}
      className="rounded"
      size="sm"
      disabled={disabled}
      style={{
        padding: "6px 19px",
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.08)",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        backgroundColor: "#ffffff",
        borderColor: "#dee2e6",
        borderWidth: "1px",
        borderStyle: "solid",
        color: "#212529",
        transition: "all 0.2s ease",
        cursor: disabled ? "not-allowed" : "pointer"
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = "#f8f9fa";
          e.currentTarget.style.borderColor = "#adb5bd";
          e.currentTarget.style.transform = "translateY(-1px)";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = "#ffffff";
          e.currentTarget.style.borderColor = "#dee2e6";
          e.currentTarget.style.transform = "translateY(0)";
        }
      }}
    >
      {icon}
      {children}
    </Button>
  );
};

export default SecondarySmallButton;
